/*
  Removes add-on lines that have lost the product they attach to.

  THE BUG THIS EXISTS FOR
  -----------------------
  BAG Care+ is sold as its own product, added from the PDP with properties pointing at
  the machine it covers (`_covers` = variant id, `_covers_line` = product handle).
  Accessories added the same way carry `_pairs_with`.

  The add path is careful - it adds the machine too if coverage would otherwise be
  orphaned. **Nothing guarded the reverse.** Remove is `updateQuantity(index, 0)` on a
  single line (assets/cart.js), so taking the machine out - with Remove, or by holding
  the minus button down to zero - left the warranty behind on its own.

  Observed in a real abandoned checkout: BAG Care+ $329 alone, the Precor TRM 885 at
  quantity 0, a 5% code applied to the warranty, total $338.34. The customer was one
  click from paying $329 for coverage on a treadmill they were not buying. Reproduced
  exactly by adding both and zeroing the machine's line.

  WHAT THIS DOES
  --------------
  After any cart change, any line whose anchor is gone is removed. The anchor counts as
  present if EITHER its variant id or its product handle is still in the cart - handle
  matching as well, so switching variant of the covered machine cannot orphan coverage
  by accident.

  Deliberately silent: the customer removed the machine, so removing its coverage is
  what they meant. It is not a decision worth a dialog.
*/
(function () {
  'use strict';

  var running = false;
  var timer = null;

  function anchorOf(item) {
    var p = item.properties || {};
    /* _covers is Care+; _pairs_with is a paired accessory. Both are anchors. */
    var id = p._covers || p._pairs_with || null;
    if (!id) return null;
    return { id: String(id), handle: p._covers_line ? String(p._covers_line) : null };
  }

  async function sweep() {
    if (running) return;
    running = true;

    try {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var items = cart.items || [];
      if (!items.length) return;

      /* Everything actually being bought. A line at quantity 0 does not count -
         Shopify normally drops those, but never rely on it. */
      var liveIds = {}, liveHandles = {};
      items.forEach(function (it) {
        if (it.quantity > 0) {
          liveIds[String(it.variant_id || it.id)] = true;
          if (it.handle) liveHandles[String(it.handle)] = true;
        }
      });

      var orphans = [];
      items.forEach(function (it) {
        var a = anchorOf(it);
        if (!a) return;
        var present = liveIds[a.id] || (a.handle && liveHandles[a.handle]);
        if (!present) orphans.push({ key: it.key, title: it.title });
      });

      if (!orphans.length) return;

      for (var i = 0; i < orphans.length; i++) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: orphans[i].key, quantity: 0 })
          });
        } catch (e) { /* leave it rather than break the cart */ }
      }

      /* Tell the theme to repaint. Guarded by `running` above, and the next sweep
         finds nothing to do, so this cannot loop. */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof window.ctxRefreshCart === 'function') window.ctxRefreshCart();

      /* The full cart page renders server-side and will not repaint from an event. */
      if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
    } catch (e) {
      /* Never let this throw into someone's checkout flow. */
    } finally {
      running = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    /* Debounced: holding the minus button fires a burst of cart changes, and the
       cart is only wrong once they stop. */
    timer = setTimeout(sweep, 350);
  }

  /* Cart changes arrive by several routes, so listen broadly rather than guess:
     - the theme's own refresh events
     - the drawer re-rendering its markup (covers Remove and the quantity stepper)
     - page load, which covers the full cart page and any path missed above */
  ['cart:refresh', 'cart:build', 'cart:updated'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, schedule);
    document.addEventListener(evt, schedule);
  });

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.ctxGuardWatched) return;
    drawer.dataset.ctxGuardWatched = '1';
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  }

  function start() { watchDrawer(); schedule(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
